import { createFileRoute } from "@tanstack/react-router"

import PrivacyPage from "@/features/static/components/privacy"

export const Route = createFileRoute("/_screen/privacy")({
  component: Privacy
})

function Privacy() {
  return <PrivacyPage />
}
